import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  order: 0;\n  flex: 0 1 auto;\n  height: 100%;\n  width: 0px;\n  position: relative;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 0;\n  height: ", "px;\n  position: absolute;\n  top: calc(50% - ", "px);\n  right: ", "px;\n  z-index: 99;\n  line-height: ", "px;\n  border: ", "px solid transparent;\n  border-left: ", "px solid #ebebeb;\n  cursor: pointer;\n  color: #bfbfbf;\n  transition: right 0.1s ease-in-out, border 0.1s ease;\n\n  &:hover {\n    right: ", "px;\n    border-left-color: #dedede;\n\n    ", " {\n      color: #888888;\n    }\n  }\n\n  ", " {\n    width: ", "px;\n    position: relative;\n    left: ", "px;\n    color: #c1c1c1;\n    transform: rotate(", "deg);\n    transition: transform 0.5s ease-in-out, left 0.1s ease-in-out;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  order: 0;\n  flex: 0 1 auto;\n  height: 100%;\n  background-color: #f5f5f5;\n  overflow-x: hidden;\n  overflow-y: ", ";\n  width: ", "px;\n  min-width: ", "px;\n  transition: width 0.3s ease-in-out, min-width 0.3s ease-in-out;\n  position: relative;\n  z-index: 100;\n\n  ", " {\n    position: relative;\n    left: ", "px;\n    transition: left 0.3s ease-in-out;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  min-width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Icon } from '@alicloud/console-components';
import styled from 'styled-components';
var navWidth = 210;
var navCollapsedWidth = 8;
var triggerHeight = 64;
var triggerWidth = 18;
var iconWidth = 12;
var evulsedWidth = 2;

var calcWidth = function calcWidth(props) {
  return props.collapsed ? navCollapsedWidth : navWidth;
};

var calcOverflow = function calcOverflow(props) {
  return props.collapsed ? 'hidden' : 'auto';
};

var calcLeft = function calcLeft(props) {
  return props.collapsed ? navCollapsedWidth - navWidth : 0;
};

var getRotate = function getRotate(props) {
  return props.collapsed ? 180 : 0;
};

export var NavChildenWrapper = styled.div(_templateObject(), navWidth, navWidth);
var Nav = styled.div(_templateObject2(), calcOverflow, calcWidth, calcWidth, NavChildenWrapper, calcLeft);
export default Nav;
export var NavCollapseTriggerIcon = styled(Icon)(_templateObject3());
export var NavCollapseTrigger = styled.span(_templateObject4(), triggerHeight, triggerHeight / 2, -triggerWidth - triggerWidth / 2, triggerHeight - 18, triggerWidth / 2, triggerWidth + evulsedWidth, -triggerWidth - triggerWidth / 2 - evulsedWidth, NavCollapseTriggerIcon, NavCollapseTriggerIcon, iconWidth, -(triggerWidth / 2) - iconWidth / 2, getRotate);
export var NavCollapseTriggerWrapper = styled.div(_templateObject5());